/**
 * @generated SignedSource<<1fadad0d5c5ef13af02f9085f812b0d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "batchFinish"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "batchStart"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meterId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeZone"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tradeAggregation"
},
v5 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "meterId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "aggregation",
      "variableName": "tradeAggregation"
    },
    {
      "kind": "Variable",
      "name": "finish",
      "variableName": "batchFinish"
    },
    {
      "kind": "Literal",
      "name": "groups",
      "value": [
        "SUMMARY_GROUP_TRADE_POINT",
        "SUMMARY_GROUP_TRADE_RULE",
        "SUMMARY_GROUP_DIRECTION",
        "SUMMARY_GROUP_TRADE_TYPE"
      ]
    },
    {
      "kind": "Variable",
      "name": "start",
      "variableName": "batchStart"
    },
    {
      "kind": "Variable",
      "name": "timeZone",
      "variableName": "timeZone"
    }
  ],
  "concreteType": "TradeSetSummary",
  "kind": "LinkedField",
  "name": "tradeSetSummary",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeSetSummaryKey",
      "kind": "LinkedField",
      "name": "key",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tradePointId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ruleId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "direction",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeSetSummaryValue",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRange",
          "kind": "LinkedField",
          "name": "range",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "finish",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "buyerTradePointIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sellerTradePointIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "directions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "types",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "volume",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "averagePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tradesCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "intervalsCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": {
      "throwOnFieldError": true
    },
    "name": "dataBatchingMeterTradeSetSummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Meter",
        "kind": "LinkedField",
        "name": "meter",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "dataBatchingMeterTradeSetSummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Meter",
        "kind": "LinkedField",
        "name": "meter",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e75f744ac9b82ec8391bc3c62de311be",
    "id": null,
    "metadata": {},
    "name": "dataBatchingMeterTradeSetSummaryQuery",
    "operationKind": "query",
    "text": "query dataBatchingMeterTradeSetSummaryQuery(\n  $meterId: ID!\n  $batchStart: Timestamp!\n  $batchFinish: Timestamp!\n  $timeZone: String!\n  $tradeAggregation: String!\n) {\n  meter(uuid: $meterId) {\n    uuid\n    tradeSetSummary(start: $batchStart, finish: $batchFinish, timeZone: $timeZone, aggregation: $tradeAggregation, groups: [SUMMARY_GROUP_TRADE_POINT, SUMMARY_GROUP_TRADE_RULE, SUMMARY_GROUP_DIRECTION, SUMMARY_GROUP_TRADE_TYPE]) {\n      key {\n        tradePointId\n        ruleId\n        direction\n        type\n      }\n      data {\n        range {\n          start\n          finish\n        }\n        buyerTradePointIds\n        sellerTradePointIds\n        directions\n        types\n        value\n        volume\n        averagePrice\n        tradesCount\n        intervalsCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "c15a38c5c023da8551376ebd84bd9037";

export default node;
